import type { RootLoaderData } from "../root";
import { useRouteData } from "./useRouteData";

export function useRootLoaderData(): RootLoaderData {
  return useRouteData<RootLoaderData>("root")!;
}
